<template>
  <div class="admin container mx-auto">
    <div class="capitalize font-bold">{{ $route.params.id }}</div>
    <div class="mb-4">
      <Calendar is-expanded title-position="left" :attributes="attributes" locale="fr" />
      <router-link
        to="add"
        class="inline-block font-bold text-sm text-white bg-blue-400 hover:bg-blue-500 rounded px-3 py-2 mt-2"
      >
        + Ajouter
      </router-link>
    </div>
    <div class="mb-4">
      <!-- <VenueFilters :filter="venueFilter" @updateFilter="venueFilter = $event" /> -->
      <div class="flex flex-row">
        <StatusFilters :filter="statusFilter" @updateFilter="statusFilter = $event" />
        <!--
        <button
          class="inline-block font-bold text-sm border-solid border-2 border-gray-300 rounded px-3 py-2 mr-1 mb-1"
          :class="{ 'bg-gray-600 text-white border-gray-600 text-white': active }"
        >
          <i v-if="icon" :class="`fas fa-${icon} text-${active ? color : 'gray'}-300 mr-1`"></i>

          {{ label }}
        </button> -->
      </div>

      <TimeFilters :filter="timeFilter" @updateFilter="timeFilter = $event" />
    </div>

    <Loader v-if="loading" />

    <div v-if="!loading">
      <transition-group name="list" tag="div" class="list">
        <div
          v-for="booking of filteredBookings"
          :key="booking.id"
          class="list-item bg-white p-2 my-1 rounded flex flex-col justify-between border-2 mb-6 md:grid md:grid-cols-3 "
          :class="
            booking.confirmed
              ? `border-solid border-${booking.current ? 'blue' : 'green'}-400`
              : booking.canConfirm
              ? 'border-dashed border-yellow-400'
              : 'border-dashed border-red-400'
          "
        >
          <div class="status">
            <i
              v-if="booking.confirmed"
              class="fas fa-check-circle text-xl"
              :class="booking.current ? 'text-blue-300' : 'text-green-300'"
            ></i>
            <i v-if="!booking.confirmed" class="fas fa-hourglass-half text-yellow-300 text-xl"></i>
          </div>

          <div class="text-left mb-4">
            <!-- <div class="flex flex-row items-center">
              <i
                v-if="booking.venue === 'trebeurden'"
                class="fas fa-fish text-xl text-blue-300 mr-2"
              ></i>
              <i
                v-if="booking.venue === 'robertville'"
                class="fas fa-tree text-xl text-green-300 mr-2"
              ></i>
              <div class="capitalize font-bold">{{ booking.venue }}</div>
            </div> -->

            <div class="text-indigo-400">
              <span class="font-medium text-xl">
                {{ booking.duration }}
              </span>
              <i class="fas fa-moon"></i>
            </div>

            <div>
              <!-- <i class="fas fa-calendar-alt text-gray-400"></i> -->
              {{ booking.from2 }}
              <i class="fas fa-arrow-right text-gray-300"></i>
              {{ booking.to2 }}
            </div>

            <!-- <div v-if="booking.price" class="text-xl text-indigo-400">{{ booking.price }} €</div> -->
          </div>

          <div class="text-left mb-4">
            <div class="font-bold">{{ booking.name }}</div>
            <i class="fas fa-phone text-gray-300 mr-1"></i>
            <a v-if="booking.phone" class="underline" :href="`tel:${booking.phone}`">
              {{ booking.phone }}
            </a>
            <br />
            <i class="fas fa-envelope text-gray-300 mr-1"></i>
            <a class="underline" :href="`mailto:${booking.email}`">{{ booking.email }}</a>

            <div class="text-left">
              <i class="fas fa-comment text-gray-300 mr-1"></i>
              {{ booking.comment }}
            </div>
          </div>

          <div
            v-if="booking.timeGroup !== 'archived'"
            class="text-right flex justify-end items-end"
          >
            <button
              v-if="!booking.confirmed && booking.canConfirm"
              class="rounded bg-green-400 text-white font-bold p-2 hover:bg-green-500 transition"
              @click="confirm(booking)"
            >
              <i class="fas fa-check mr-1"></i>
              Confirmer
            </button>

            <div
              v-if="!booking.confirmed && !booking.canConfirm"
              class="font-medium p-2 text-red-400"
            >
              Conflit de dates
            </div>

            <!-- <button class="rounded bg-green-300 text-white  p-2 mr-1" @click="confirm(booking)">
              {{ booking.confirmed ? 'Annuler' : 'Confirmer' }}
            </button> -->

            <button
              class="rounded bg-red-400 text-white font-bold p-2 ml-2 hover:bg-red-500 transition"
              @click="remove(booking)"
            >
              <i v-if="!booking.confirmed" class="fas fa-times mr-1"></i>
              <i v-if="booking.confirmed" class="fas fa-trash mr-1"></i>
              {{ booking.confirmed ? 'Annuler' : 'Refuser' }}
            </button>
          </div>
        </div>

        <div v-if="filteredBookings.length === 0" key="none">
          Aucun résultat.
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import * as api from '../api';
import moment from 'moment';
import Loader from '../components/Loader.vue';
import VenueFilters from '../components/VenueFilters.vue';
import StatusFilters from '../components/StatusFilters.vue';
import TimeFilters from '../components/TimeFilters.vue';
import { French } from 'flatpickr/dist/l10n/fr.js';
// FIXME: PREVENT DATE OVERLAP
import Calendar from 'v-calendar/lib/components/calendar.umd';
export default {
  name: 'Admin',

  components: { Loader, VenueFilters, StatusFilters, TimeFilters, Calendar },

  data() {
    return {
      loading: true,
      bookings: [],

      venueFilter: this.$route.params.id,
      statusFilter: 'waiting',
      timeFilter: 'active',
    };
  },

  mounted() {
    this.fetchData();
  },

  computed: {
    filteredBookings() {
      let bookings = this.bookings.map(booking => {
        booking.duration = Math.round((moment(booking.to) - moment(booking.from)) / 3600 / 1000 / 24);
        booking.from2 = moment(booking.from).format('D.MM.Y');
        booking.to2 = moment(booking.to).format('D.MM.Y');
        // booking.price = booking.duration * 80; // TODO: pricing formula
        booking.current = false;

        const now = new Date();
        const start = new Date(booking.from);
        const end = new Date(booking.to);

        if (start <= now && end >= now) {
          booking.current = true;
          booking.timeGroup = 'active';
        } else if (end < now) {
          booking.timeGroup = 'archived';
        } else {
          booking.timeGroup = 'active';
        }

        booking.canConfirm =
          !booking.confirmed &&
          !this.bookings
            .filter(({ confirmed }) => confirmed)
            .find(booking => {
              const otherStart = new Date(booking.from);
              const otherEnd = new Date(booking.to);
              if (start <= otherStart && end >= otherEnd) {
                return true;
              } else {
                return false;
              }
            });

        console.log(booking.canConfirm);

        return booking;
      });

      if (this.venueFilter) {
        bookings = bookings.filter(booking => booking.venue === this.venueFilter);
      }

      if (this.timeFilter) {
        bookings = bookings.filter(booking => booking.timeGroup === this.timeFilter);
      }

      if (this.statusFilter) {
        bookings = bookings.filter(
          booking => booking.confirmed === (this.statusFilter === 'confirmed'),
        );
      }

      return bookings;
    },

    attributes() {
      return [
        ...this.bookings.map(booking => {
          let result = {
            dates: {
              start: booking.from,
              end: booking.to,
            },
            popover: {
              label: booking.name,
            },
            customData: booking,
          };

          if (booking.confirmed) {
            result.highlight = {
              start: { fillMode: 'solid', color: 'green' },
              base: { fillMode: 'light', color: 'green' },
              end: { fillMode: 'solid', color: 'green' },
            };
          } else {
            result.highlight = {
              start: { fillMode: 'solid', color: 'orange' },
              base: { fillMode: 'light', color: 'orange' },
              end: { fillMode: 'solid', color: 'orange' },
            };
          }
          // result.dot = { color: 'orange' };

          return result;
        }),
      ];
    },
  },

  methods: {
    async fetchData() {
      try {
        this.bookings = await api.fetchAdminBookings({ venue: this.$route.params.id });
      } catch (err) {
        console.error(err);
        if (err.response.status === 401) {
          localStorage.removeItem('jwt');
          this.$router.replace({ name: 'login' });
        }
      }

      this.loading = false;
    },

    async confirm(booking) {
      const result = await api.updateBooking(booking.id, { confirmed: !booking.confirmed });
      // IMPROVEMENT: update item
      this.fetchData();
    },

    async remove(booking) {
      await api.deleteBooking(booking.id);
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
}
.status {
  position: absolute;
  top: 10px;
  right: 10px;
}
.list {
  position: relative;
}
.list-item {
  position: relative;
  transition: all 0.7s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  // transform: scaleY(0.9);
}
.list-leave-active {
  position: absolute;
  right: 0;
  left: 0;
}
</style>
